import classNames from "classnames";
import styles from "./styles.module.scss";
import CheckIcon from "@assets/icons/CheckIcon.svg";
import ProductCode from "@components/ProductCode";
import Star from "@assets/icons/Star";

interface ProductCardProps {
  item: {
    asin: string;
    item_name: string;
    image_link: string;
    price: number;
    brand: string;
    bullet_points: string[];
    link: string;
  };
  selected?: boolean;
  onSelect?: (item: ProductCardProps["item"]) => void;
}

export const ProductCard = ({
  item,
  selected = false,
  onSelect,
}: ProductCardProps) => {
  return (
    <div className={styles.productCard}>
      <img
        src={item.image_link}
        alt={item.item_name}
        className={styles.productCard__image}
      />
      <div className={styles.productCard__content}>
        <h3>{item.item_name}</h3>
        <div className={styles.rating}>
          <Star />
          <span>4.5</span>
        </div>
        <ProductCode code={item?.asin ?? ""} />
      </div>
      <button
        className={classNames(styles.btnSelect, {
          [styles.selected]: selected,
        })}
        onClick={() => onSelect?.(item)}
      >
        {selected && <img src={CheckIcon} alt="checked" />}
        select
      </button>
    </div>
  );
};
